import * as types from './actionTypes'
import { createRequestActions } from 'helpers'

export const proTrackList = {
  get: createRequestActions({
    request: types.STORIES_GET_PROTRACKS.GET.REQUEST,
    success: types.STORIES_GET_PROTRACKS.GET.SUCCESS,
    fail: types.STORIES_GET_PROTRACKS.GET.FAIL,
  }),
}

export const storiesList = {
  get: createRequestActions({
    request: types.STORIES.GET.REQUEST,
    success: types.STORIES.GET.SUCCESS,
    fail: types.STORIES.GET.FAIL,
  }),
}

export const storiesLoadMore = {
  get: createRequestActions({
    request: types.STORIES_LOAD_MORE.GET.REQUEST,
    success: types.STORIES_LOAD_MORE.GET.SUCCESS,
    fail: types.STORIES_LOAD_MORE.GET.FAIL,
  }),
}

export const enableStoriesLoadMorePending = {
  type: types.STORIES_ENABLE_LOAD_MORE_PENDING,
}

export const enableStoriesGetPending = {
  type: types.STORIES_ENABLE_PENDING,
}

export const storiesScroll = ({ scrollTop, clientHeight, scrollHeight }) => ({
  type: types.STORIES_SCROLL,
  payload: {
    scrollTop,
    clientHeight,
    scrollHeight,
  },
})
